import React, { CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { PartyBarData } from 'lib/PartyBar/partybar.types';

interface Props {
  lists: PartyBarData[];
  hoveredListId: number;
  setHoveredListId: (id: number) => void;
}

const SeatsLegend = ({ lists, hoveredListId, setHoveredListId }: Props) => {
  const { t } = useTranslation('wap');

  return (
    <ol className="chartlegend">
      {lists.map(({ listId, color, seatsClaimed, shortTitle }) => (
        <li
          key={listId}
          onMouseEnter={() => setHoveredListId(listId)}
          onMouseLeave={() => setHoveredListId(null)}
          className={classNames('seatchart__legend-item', {
            'seatchart__legend-item--hovered': listId === hoveredListId,
          })}
        >
          <span
            className="seatchart__legend-item-color"
            style={{ '--color': color } as CSSProperties}
          />
          <span className="seatchart__legend-item-seats">
            {t('seats', { count: seatsClaimed })}
          </span>
          <span className="seatchart__legend-item-list">{shortTitle}</span>
        </li>
      ))}
    </ol>
  );
};

export default SeatsLegend;
